import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Number$parseInt from "@babel/runtime-corejs3/core-js-stable/number/parse-int";
import React, { useEffect, useState, useRef, useMemo } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DateField, Dialog } from '@unite-us/ui';
import { hooks } from '../../../config/api';
import { theme } from '../../../../tailwind.config';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import EditButton from '../../common/EditButton';
import Spinner from '../../common/spinners/Spinner';
import { PrimaryButton } from '../../common/TailwindComponents';
import today from '../../utils/today';
import { useUpdateSocialInsurance } from '../hooks';
import { CancelEnrollmentRequestModal } from './CancelEnrollmentRequestModal';
import { INSURANCE_STATUSES } from './constants';
import { DisenrollModal } from './DisenrollModal';
import { ContinueEnrollmentModal } from './ContinueEnrollmentModal';
import { EditSocialInsuranceModalMessage } from './EditSocialInsuranceModalMessage';
import { SocialInsuranceStartDate, SocialInsuranceEndDate } from './SocialInsuranceDates';
export var EditSocialInsurance = function EditSocialInsurance(_ref) {
  var _insurance$plan, _insurance$plan2;
  var goToEnrollmentWorkflow = _ref.goToEnrollmentWorkflow,
    insuranceId = _ref.insuranceId;
  var _hooks$useFindRecord = hooks.useFindRecord('insurance', insuranceId, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    isLoading = _hooks$useFindRecord.isLoading,
    response = _hooks$useFindRecord.data;
  var insurance = useMemo(function () {
    var _response$data$data, _response$data;
    return (_response$data$data = response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) !== null && _response$data$data !== void 0 ? _response$data$data : {};
  }, [response]);
  var _hooks$usePopulate = hooks.usePopulate('plan', 'plan', insurance, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    isPlanPopulating = _hooks$usePopulate.isLoading;
  var _hooks$usePopulate2 = hooks.usePopulate('person', 'person', insurance, {
      queryConfig: {
        placeholderData: undefined
      }
    }),
    isPersonPopulating = _hooks$usePopulate2.isLoading;
  var isAnythingLoading = isLoading || isPlanPopulating || isPersonPopulating;
  var hasEnrollmentWQ = useFeatureFlag('enrollment-wq');
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    enrolledAtUnixString = _useState2[0],
    setEnrolledAtUnixString = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    expiredAtUnixString = _useState4[0],
    setExpiredAtUnixString = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCancelDialogOpen = _useState6[0],
    setIsCancelDialogOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDisenrollDialogOpen = _useState8[0],
    setIsDisenrollDialogOpen = _useState8[1];
  var continueEnrollmentModalRef = useRef(null);
  var socialInsuranceEditModalRef = useRef(null);
  var updateRecord = useUpdateSocialInsurance();
  var onClose = function onClose() {
    return socialInsuranceEditModalRef.current.closeDialog();
  };
  var onCancelButton = function onCancelButton() {
    setIsCancelDialogOpen(true);
  };
  var onDisenrollButton = function onDisenrollButton() {
    setIsDisenrollDialogOpen(true);
  };
  var openContinueEnrollmentModal = function openContinueEnrollmentModal() {
    continueEnrollmentModalRef.current.onOpen();
    onClose();
  };
  useEffect(function () {
    setEnrolledAtUnixString(insurance.enrolled_at ? moment(insurance.enrolled_at).unix().toString() : '');
    setExpiredAtUnixString(insurance.expired_at ? moment(insurance.expired_at).unix().toString() : '');
  }, [insurance]);
  var openSocialInsuranceEditModal = function openSocialInsuranceEditModal() {
    socialInsuranceEditModalRef.current.openDialog();
  };
  var handleSaveUpdate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return updateRecord(insurance.id, {
              enrolled_at: enrolledAtUnixString ? moment.unix(_Number$parseInt(enrolledAtUnixString, 10)).toISOString(false) : null,
              expired_at: expiredAtUnixString ? moment.unix(_Number$parseInt(expiredAtUnixString, 10)).toISOString(false) : null
            });
          case 2:
            onClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSaveUpdate() {
      return _ref2.apply(this, arguments);
    };
  }();
  return isAnythingLoading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/React.createElement(EditButton, {
    edit: openSocialInsuranceEditModal,
    id: "edit-insurance-".concat(insuranceId),
    "aria-label": "edit-insurance-".concat(insuranceId),
    labelText: "Edit"
  }), /*#__PURE__*/React.createElement(Dialog, {
    id: "edit-social-care-modal",
    ref: socialInsuranceEditModalRef,
    title: "Edit social care coverage",
    modal: true,
    onRequestClose: onClose,
    "data-testid": "edit-social-care-modal",
    actions: !hasEnrollmentWQ ? /*#__PURE__*/React.createElement(PrimaryButton, {
      className: "action-item border-dark-pale-blue",
      onClick: handleSaveUpdate,
      label: "Save",
      disabled: !enrolledAtUnixString
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, insurance.insurance_status === INSURANCE_STATUSES.enrolled && /*#__PURE__*/React.createElement(PrimaryButton, {
      className: "action-item border-dark-pale-blue",
      label: "Disenroll Client",
      onClick: onDisenrollButton
    }), insurance.insurance_status === INSURANCE_STATUSES.rejected && /*#__PURE__*/React.createElement(PrimaryButton, {
      className: "action-item border-dark-pale-blue",
      label: "Next",
      onClick: function onClick() {
        openContinueEnrollmentModal();
      }
    }), (insurance.insurance_status === INSURANCE_STATUSES.pending_enrollment || insurance.insurance_status === INSURANCE_STATUSES.pending_disenrollment) && /*#__PURE__*/React.createElement(PrimaryButton, {
      className: "action-item border-dark-pale-blue",
      label: "Cancel Request",
      onClick: onCancelButton
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4 mb-4"
  }, /*#__PURE__*/React.createElement(EditSocialInsuranceModalMessage, {
    insuranceStatus: insurance.insurance_status,
    planName: (_insurance$plan = insurance.plan) === null || _insurance$plan === void 0 ? void 0 : _insurance$plan.name
  }), /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uppercase text-dark-blue text-xs font-heavy-font tracking-wider"
  }, "Social Care Coverage"), /*#__PURE__*/React.createElement("div", {
    role: "heading",
    "aria-level": "5"
  }, (_insurance$plan2 = insurance.plan) === null || _insurance$plan2 === void 0 ? void 0 : _insurance$plan2.name)), hasEnrollmentWQ ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SocialInsuranceStartDate, {
    value: insurance.enrolled_at
  }), /*#__PURE__*/React.createElement(SocialInsuranceEndDate, {
    value: insurance.expired_at
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateField, {
    label: "Start Date",
    id: "edit-social-insurance-start-date",
    maxDate: today(),
    placeholder: "MM/DD/YYYY",
    isUtc: true,
    required: true,
    value: enrolledAtUnixString,
    onChange: setEnrolledAtUnixString,
    style: {
      error: {
        height: 0
      },
      label: {
        color: theme.extend.colors['dark-blue']
      }
    }
  }), /*#__PURE__*/React.createElement(DateField, {
    label: "End Date",
    id: "edit-social-insurance-end-date",
    minDate: enrolledAtUnixString || today(),
    placeholder: "MM/DD/YYYY",
    value: expiredAtUnixString,
    onChange: setExpiredAtUnixString,
    style: {
      error: {
        height: 0
      },
      label: {
        color: theme.extend.colors['dark-blue']
      }
    }
  })))), /*#__PURE__*/React.createElement(CancelEnrollmentRequestModal, {
    insurance: insurance,
    isConfirmDialogOpen: isCancelDialogOpen,
    onDialogStateChange: setIsCancelDialogOpen
  }), /*#__PURE__*/React.createElement(DisenrollModal, {
    insurance: insurance,
    onClose: function onClose() {
      return setIsDisenrollDialogOpen(false);
    },
    open: isDisenrollDialogOpen
  }), /*#__PURE__*/React.createElement(ContinueEnrollmentModal, {
    ref: continueEnrollmentModalRef,
    insurance: insurance,
    goToEnrollmentWorkflow: goToEnrollmentWorkflow
  }));
};
EditSocialInsurance.propTypes = {
  goToEnrollmentWorkflow: PropTypes.func.isRequired,
  insuranceId: PropTypes.string.isRequired
};
//# sourceMappingURL=EditSocialInsurance.js.map